<template>
    <div>
        <div class="card border-primary mb-3">
            <div class="card-body">
                <!-- {{model}} -->

                <div class="row">
                    <div v-if="!saving" class="form-group col-12">
                        <label
                            class="font-weight-bold"
                            :for="'parent' + _uid"
                            >{{ $t('help.parent') }}</label
                        >
                        <dynamic-dropdown ref="'parentsDropdown'"
                            :apiUrl="`/api/help/getMenuIemsDropdownModels`"
                            v-model="model.parentId"
                            :id="'parent' + _uid"
                            :name="'parent' + _uid"
                            :fieldName="$t('help.parent')"
                            :filter="'contains'"
                            :showGoToSelection="false"
                            :height="800"
                        >
                        </dynamic-dropdown>
                    </div>

                    <div class="form-group col-12">
                        <label
                            class="font-weight-bold required"
                            :for="'name' + _uid"
                        >
                            {{ $t("help.name") }}
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.name"
                            v-validate="'required'"
                            :data-vv-as="$t('help.name')"
                            :name="'name' + _uid"
                            :id="'name' + _uid"
                        />
                        <span
                            class="text-danger col-12"
                            v-if="errors.has('name' + _uid)"
                            >{{ errors.first('name' + _uid) }}</span
                        >
                    </div>

                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'nameEn' + _uid">
                            {{ $t('help.nameEn') }}
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.nameEn"
                            :name="'nameEn' + _uid"
                            :id="'nameEn' + _uid"
                        />
                    </div>

                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'sort' + _uid">
                            {{ $t('help.sort') }}
                        </label>
                        <input
                            type="number"
                            min="0"
                            max="32767"
                            step="1"
                            class="form-control"
                            v-validate="'numeric'"
                            :data-vv-as="$t('help.sort')"
                            v-model="model.sort"
                            :name="'sort' + _uid"
                            :id="'sort' + _uid"
                        />
                        <span
                            class="text-danger col-12"
                            v-if="errors.has('sort' + _uid)"
                            >{{ errors.first('sort' + _uid) }}</span
                        >
                    </div>

                    <div class="form-group col-12 mt-3">
                        <vs-checkbox
                            v-model="model.deactivated"
                            :name="'deactivated' + _uid"
                            :id="'deactivated' + _uid"
                            style="justify-content: flex-start !important"
                        >
                            {{ $t('help.deactivated') }}
                        </vs-checkbox>
                    </div>
                </div>
            </div>

            <div class="footer">
                <div class="text-right mt-3">
                    <div
                        class="btn-group"
                        role="group"
                        aria-label="Role edit buttons"
                    >
                        <button
                            type="button"
                            class="btn btn-success"
                            :disabled="saving"
                            @click.stop="onSave"
                        >
                            <i v-if="saving"
                                class="fas fa-spinner fa-spin mr-2"
                            ></i>
                            <i v-else class="fas fa-save mr-2"></i
                            >{{ $t('buttons.save.btnText') }}
                        </button>
                        <button
                            type="button"
                            class="btn btn-danger"
                            :disabled="saving"
                            @click.stop="onCancel"
                        >
                            <i class="fas fa-ban mr-2"></i
                            >{{ $t('buttons.cancel') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { UserHelp } from "@/models/models";
import service from "@/services/help.service";
import DynamicDropdown from "@/components/dropdown/DynamicDropdown";

export default {
    inject: ["$validator"],
    props: {
        value: {
            type: UserHelp,
            required: false,
        },
    },
    components: {
        DynamicDropdown,
    },
    data() {
        return {
            model: this.value,
            saving: false
        };
    },
    methods: {
        onCancel() {
            this.$emit("cancel");
        },
        onSave() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.doSave();
                }
            });
        },
        doSave() {
            this.saving = true;
            service
                .saveMenuItemData(this.model)
                .then((response) => {
                    this.$vs.notify({
                        title: this.$t("buttons.save.btnText"),
                        text: this.$helpers.responseMessage(response),
                        color: "success",
                        time: this.$store.getters.notificationDuration,
                    });

                    this.$emit("save", this.model);
                    const dropDown = this.$refs.parentsDropdown;
                    if (dropDown) {
                        dropDown.loadItems();
                    }
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: this.$t("buttons.save.btnText"),
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .then(() => { this.saving = false; });
        },
    },
    watch: {
        value: function (val) {
            if (val) {
                this.model = new UserHelp(this.value);
            }
        },
    },
};
</script>

<style scoped>
input[readonly] {
    background-color: whitesmoke;
}

textarea[readonly] {
    background-color: whitesmoke;
}
</style>
